import React from 'react';
import { motion } from 'framer-motion';
const steps = [{
  title: 'The Strip & Pre-Treat',
  desc: "You trigger the 'Laundry Anchor' and let chemistry break down grime while you move."
}, {
  title: 'The Tactical Sprint',
  desc: "You follow the 'Back-Out' path so you never repeat a movement."
}, {
  title: 'The Visual Audit',
  desc: 'You clear the 5 high-impact zones that guarantee the 5-star rating.'
}];
export function HowItWorks() {
  return <section className="bg-brand-darker py-24 text-white" data-id="element-49">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-50">
        <div className="text-center mb-16" data-id="element-51">
          <h2 className="text-4xl sm:text-5xl text-white mb-4" data-id="element-52">HOW IT WORKS</h2>
          <div className="w-24 h-1 bg-brand-yellow mx-auto" data-id="element-53"></div>
        </div>

        <div className="space-y-8 relative before:absolute before:inset-0 before:ml-8 before:-translate-x-px md:before:mx-auto md:before:translate-x-0 before:h-full before:w-0.5 before:bg-gradient-to-b before:from-transparent before:via-white/20 before:to-transparent" data-id="element-54">
          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group is-active" data-id="element-55">
              {/* Icon */}
              <div className="flex items-center justify-center w-16 h-16 rounded-full border-4 border-brand-darker bg-brand-yellow text-brand-dark font-display text-3xl shrink-0 md:order-1 md:group-odd:-translate-x-1/2 md:group-even:translate-x-1/2 shadow-[0_0_20px_rgba(250,204,21,0.3)] z-10" data-id="element-56">
                {index + 1}
              </div>

              {/* Card */}
              <div className="w-[calc(100%-5rem)] md:w-[calc(50%-3rem)] bg-white/5 border border-white/10 p-6 sm:p-8 rounded-2xl hover:bg-white/10 transition-colors" data-id="element-57">
                <h3 className="text-2xl font-display text-brand-yellow mb-3 tracking-wide" data-id="element-58">
                  {step.title}
                </h3>
                <p className="text-gray-300 text-lg leading-relaxed" data-id="element-59">
                  {step.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}